import { Injectable } from '@angular/core';
import { retry, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ErrorProcessorService }  from "../../shared/services/error-processor.service";
import { IMyArtifact } from 'src/app/interfaces/my-artifact';
import { IDropDown } from 'src/app/interfaces/drop-down';

@Injectable({
  providedIn: 'root'
})
export class ArtifactService {


  protected baseUrl = environment.apiServer.portalUrl;


  constructor(
    private http: HttpClient,
    private errorProcessorService: ErrorProcessorService
  ) { }

  getMyArtifacts(artifactId: string,selectedDateFrom: string,
    selectedDateTo: string): Observable<IMyArtifact[]> {
    return this.http.get<IMyArtifact[]>(this.baseUrl + '/artifacts?from='+selectedDateFrom +'&to='+selectedDateTo +'&artifactId='+artifactId
      , {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }

  getArtifactTypes(): Observable<IDropDown[]> {
    return this.http.get<IDropDown[]>(this.baseUrl + '/artifacts/types', {responseType: 'json'})
    .pipe(
      catchError(this.errorProcessorService.handleError)
    )
  }



downloadArtifact(artifactId: string): Observable<HttpResponse<ArrayBuffer>> {
  return this.http.get(this.baseUrl + '/artifacts/' + artifactId + '/content', {
    responseType: 'arraybuffer',
    observe: 'response'
  });
}



}

